import React from "react";

interface BenefitCardProps {
  icon?: React.ReactNode;
  image?: string;
  title: string;
  description: React.ReactNode;
}

const BenefitCard: React.FC<BenefitCardProps> = ({
  icon,
  image,
  title,
  description,
}) => {
  return (
    <div className="flex w-full flex-col items-start justify-center gap-6 rounded-lg bg-secondary p-6">
      {/* Icon or Image */}
      {(icon || image) && (
        <div className="relative" data-svg-wrapper>
          {icon ||
            (image && (
              <img
                src={image}
                alt={title}
                className="h-[38px] w-[38px] object-contain"
              />
            ))}
        </div>
      )}

      {/* Title and Description */}
      <div className="flex w-full flex-col items-start justify-start gap-2">
        {/* Title */}
        <div className="w-full text-balance font-figtree text-base font-medium leading-relaxed text-foreground lg:text-lg">
          {title}
        </div>

        {/* Description */}
        <div className="w-full font-figtree text-base font-medium leading-relaxed text-muted-foreground">
          {description}
        </div>
      </div>
    </div>
  );
};

export default BenefitCard;
